"use strict";

var _regeneratorRuntime = require("/mnt/ramdisk/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/mnt/ramdisk/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __exportStar = this && this.__exportStar || function (m, exports) {
  for (var p in m) {
    if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tokenRefresher = void 0;

var generated_1 = require("./generated");

__exportStar(require("./generated"), exports);

function tokenRefresher(opts) {
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var tokenResponse, token, expiryDate, body;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!opts.force) {
              _context.next = 4;
              break;
            }

            _context.next = 3;
            return refreshToken(opts);

          case 3:
            return _context.abrupt("return", _context.sent);

          case 4:
            tokenResponse = opts.tokenAccessor();
            token = tokenResponse.access_token;

            if (!(!token || token.split(".").length !== 3)) {
              _context.next = 10;
              break;
            }

            _context.next = 9;
            return refreshToken(opts);

          case 9:
            return _context.abrupt("return", _context.sent);

          case 10:
            _context.prev = 10;
            body = JSON.parse(base64Decode(token.split(".")[1]));
            expiryDate = new Date(Math.floor(body.exp * 1000));

            if (!(new Date() < expiryDate)) {
              _context.next = 15;
              break;
            }

            return _context.abrupt("return", "Bearer ".concat(token));

          case 15:
            _context.next = 22;
            break;

          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](10);
            _context.next = 21;
            return refreshToken(opts);

          case 21:
            return _context.abrupt("return", _context.sent);

          case 22:
            _context.next = 24;
            return refreshToken(opts);

          case 24:
            return _context.abrupt("return", _context.sent);

          case 25:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[10, 17]]);
  }));
}

exports.tokenRefresher = tokenRefresher;

function base64Decode(data) {
  return typeof window !== "undefined" ? atob(data) : Buffer.from(data, "base64").toString("utf8");
}

function refreshToken(_x) {
  return _refreshToken.apply(this, arguments);
}

function _refreshToken() {
  _refreshToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(opts) {
    var api, newTokenResponse, authHeader;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            api = opts.userApi || new generated_1.UserApi(opts.config);
            _context2.next = 3;
            return api.getAuthToken("refresh_token", undefined, undefined, opts.clientId, opts.scope, opts.tokenAccessor().refresh_token);

          case 3:
            newTokenResponse = _context2.sent.data;
            opts.tokenSetter(newTokenResponse);
            authHeader = "Bearer ".concat(newTokenResponse.access_token);
            return _context2.abrupt("return", authHeader);

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _refreshToken.apply(this, arguments);
}